import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { OlaMaps } from '@app/ola-maps';
import { ContainerModel } from '@app/models/server/layout.model';
import { B2bOlaMapServices } from '@app/new-ui-lib/b2b-maps/b2b-ola-map/b2b-ola-map.services';
import { SelectedItem } from '@app/models/client/item.model';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

// secure ola map key
// set center and reset center
// set marker and remove marker
// set road mark and remove road mark

@Component({
  selector: 'app-b2b-ola-map',
  templateUrl: './b2b-ola-map.component.html',
  styleUrls: ['./b2b-ola-map.component.scss'],
  standalone: true,
  providers: [B2bOlaMapServices],
})
export class B2bOlaMapComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input({ required: true }) containerName: 'd-blp-omap' | 'm-blp-omap';
  @Input({ required: true }) center: { lat: number; lng: number };
  @Input() zoom = 12;
  // @Input() containers: ContainerModel[] = [];
  @Input() mapConfig: {
    mapProperties: ContainerModel[];
    overrideData: boolean;
    locations: any[];
  };

  @Output() centerChangedEvent: EventEmitter<{
    lat: number;
    lng: number;
  }> = new EventEmitter();

  olaMaps: OlaMaps;
  private myMap;

  mapLoaded = false;

  constructor(
    private b2bOlaMapServices: B2bOlaMapServices,
    private b2bDeviceUtilService: B2bDeviceUtilService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (!this.b2bDeviceUtilService.isServer()) {
      this.setupMap();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    /*if (this.olaMaps && this.myMap && this.mapLoaded) {
      if (changes?.mapConfig?.currentValue) {

        if (!this.mapConfig?.overrideData) {
          this.b2bOlaMapServices.setPropertyMarkers(
            this.mapConfig?.mapProperties,
          );
        } else {
          this.b2bOlaMapServices.resetMapWithNewData(
            this.mapConfig?.mapProperties,
          );
        }
      }
    }*/
  }

  loadPropertyMarkers(mapProperties: ContainerModel[]) {
    this.b2bOlaMapServices.setPropertyMarkers(mapProperties);
  }

  resetMapWithNewData(
    mapProperties: ContainerModel[],
    locations: SelectedItem[],
  ) {
    this.b2bOlaMapServices.resetMapWithNewData(
      mapProperties,
      locations,
      this.center,
    );
  }

  activatePropertyMarker(container: ContainerModel) {
    this.b2bOlaMapServices.activatePropertyMarker(container);
    let zoom: number = this.b2bOlaMapServices?.getMapZoom();
    zoom = zoom > 12 ? zoom : 12;

    this.b2bOlaMapServices.moveTo(
      { lat: container?.lat, lng: container?.lng },
      zoom,
    );
  }

  setupMap() {
    this.olaMaps = this.b2bOlaMapServices.initOlaMaps();
    this.myMap = this.b2bOlaMapServices.createListPageMap(
      this.containerName,
      this.center,
      this.zoom,
    );
    if (this.myMap) {
      this.eventRegistration();
      this.b2bOlaMapServices.setPropertyMarkers(this.mapConfig?.mapProperties);
      if (this.mapConfig?.mapProperties?.length > 0) {
        this.b2bOlaMapServices.onSelectPropertyMarker(
          this.mapConfig?.mapProperties[0],
        );
      }
      this.mapLoaded = true;
    }
  }

  setCenter() {}

  setZoom(zoom: number) {}

  removeMarker() {}

  eventRegistration() {
    /*this.myMap.on('dragend', (event) => {
      this.centerChanged(event);
    });

    this.myMap.on('zoomend', (event) => {
      this.centerChanged(event);
    });*/

    this.myMap.on('moveend', (event) => {
      this.centerChanged(event);
    });
  }

  centerChanged(event) {
    // TODO need to handle this event if we are using flyTo

    const center: { lat: number; lng: number } = {
      lat: event?.target?.transform?._center?.lat,
      lng: event?.target?.transform?._center?.lng,
    };

    this.centerChangedEvent.emit(center);
  }

  ngOnDestroy(): void {
    this.b2bOlaMapServices?.destroy();
  }
}
